import styled from "@emotion/styled";
import {  Form, Input, Select, Spin } from "antd";
import React, { FC, useEffect, useState } from "react";
import { useGetMasterDistrict, useGetMasterSubDistrict } from "hooks/useMasterData";
import { MasterProvinceData, MasterDistrictData, MasterSubDistrictData, AddressData, OrderAddressData } from "services/interface";
import { FormInstance } from "antd/es/form";

const { Option } = Select;

interface RetailAddressFormProps {
  form: FormInstance;
  is_active: boolean;
  masterProviceData: any;
  dataAddress?: OrderAddressData;
}

const RetailAddressForm: FC<RetailAddressFormProps> = (
  { is_active, form, masterProviceData, dataAddress }
  ) => {
  const [province, setProvince] = useState<MasterProvinceData[]>([]);
  const [district, setDistrict] = useState<MasterDistrictData[]>([]);
  const [subDistrict, setSubDistrict] = useState<MasterSubDistrictData[]>([]);
  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  useEffect(() => {
    if (masterProviceData) {
      setProvince(masterProviceData);
    }
  }, [masterProviceData]);

   const childrenProvince: React.ReactNode[] = [];
  province?.map((item) => {
    return childrenProvince.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterDistrictData, isLoading: districtLoading } =
    useGetMasterDistrict(provinceId);

  useEffect(() => {
    if (masterDistrictData) {
      setDistrict(masterDistrictData);
    }
  }, [masterDistrictData]);

  const childrenDistrict: React.ReactNode[] = [];
  district?.map((item) => {
    return childrenDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterSubDistrictData, isLoading: subDistrictLoading } =
    useGetMasterSubDistrict(districtId);

  useEffect(() => {
    if (masterSubDistrictData) {
      setSubDistrict(masterSubDistrictData);
    }
  }, [masterSubDistrictData]);

  const childrenSubDistrict: React.ReactNode[] = [];
  subDistrict?.map((item) => {
    return childrenSubDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  useEffect(() => {
    setProvinceId(dataAddress?.province_id ?? 0);
    setDistrictId(dataAddress?.district_id ?? 0);
    form.setFieldsValue({
      province_id: dataAddress?.province_id,
      address_text: dataAddress?.address_line_1,
      district_id: dataAddress?.district_id,
      sub_district_id: dataAddress?.sub_district_id,
      zip_code: dataAddress?.zip_code,
    })
  }, [dataAddress, form]);

  return (
    <FormWrapper>
      <FormItems
        labelAlign="left"
        label="บ้านเลขที่/ซอย/ถนน"
        name="address_text"
        // rules={[{ required: false, message: "กรุณากรอกบ้านเลขที่/ซอย/ถนน" }]}
        >
        <Input
          placeholder="บ้านเลขที่/ซอย/ถนน"
          size="small"
          autoComplete="off"
        />     
      </FormItems>
      <FormItems 
        label="จังหวัด"  
        labelAlign="left" 
        name="province_id" 
        // rules={[ruleRequired]}
      >
        <Select
          showSearch
          placeholder="จังหวัด"
          optionFilterProp="children"
          onChange={(value) => {
            setProvinceId(value);
            form.setFieldsValue({ district_id: undefined });
            form.setFieldsValue({ sub_district_id: undefined });
            form.setFieldsValue({ zip_code: undefined });
          }}
        >
          {childrenProvince}
        </Select>
      </FormItems>
      <FormItems 
        label="อำเภอ" 
        labelAlign="left" 
        name="district_id" 
        // rules={[ruleRequired]}
      >
        <Select
          showSearch
          placeholder="อำเภอ"
          optionFilterProp="children"
          onChange={(value) => {
            setDistrictId(value);
            form.setFieldsValue({ sub_district_id: undefined });
            form.setFieldsValue({ zip_code: undefined });
          }}
          notFoundContent={districtLoading ? <Spin size="small" /> : null}
          loading={districtLoading}
        >
          {childrenDistrict}
        </Select>
      </FormItems>

      <FormItems 
        label="ตำบล" 
        labelAlign="left"  
        name="sub_district_id" 
        // rules={[ruleRequired]}
      >
        <Select
          showSearch
          placeholder="ตำบล"
          optionFilterProp="children"
          onChange={(value) => {
            subDistrict.map((item) => {
              if (item.id === value) {
                form.setFieldsValue({ zip_code: item.zip_code });
              }
            });
          }}
          notFoundContent={subDistrictLoading ? <Spin size="small" /> : null}
          loading={subDistrictLoading}
        >
          {childrenSubDistrict}
        </Select>
      </FormItems>
      <FormItems 
        label="รหัสไปรษณีย์" 
        labelAlign="left" 
        name="zip_code" 
        // rules={[ruleRequired]}
      >
        <Input 
          placeholder="รหัสไปรษณีย์" 
          maxLength={5} 
          minLength={5}
          autoComplete="off"
        />
      </FormItems>
    </FormWrapper>
  );
};

export default RetailAddressForm;

const FormItems = styled(Form.Item)`
    margin-bottom: 10px;
    width:100%
`

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 2px 20px;
  background-color: #ffffffff;
`;
